export const defaultTheme = {
  token: {
    // border tokens
    borderRadius: 6,
    borderRadiusSM: 4,
    borderRadiusLG: 8,

    // spacing tokens
    padding: 16,
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    paddingMD: 20,
    paddingLG: 24,
    paddingXL: 32,
    paddingContentHorizontalLG: 24,
    marginXXS: 4,
    margin: 16,
    marginXS: 8,
    marginSM: 12,
    marginMD: 20,
    marginLG: 24,

    controlOutlineWidth: 2,
    controlHeight: 32,
    controlHeightLG: 40,
    controlTmpOutline: 'rgba(0, 0, 0, 0.02)',

    colorBgContainer: '#FFFFFF',
    colorBgContainerDisabled: 'rgba(0, 0, 0, 0.04)',
    colorBorder: '#d9d9d9',
    colorPrimary: '#1677FF',
    colorText: 'rgba(0, 0, 0, 0.88)',
    colorTextBase: '#000000',
    colorTextLabel: 'rgba(0, 0, 0, 0.65)',
    colorTextTertiary: 'rgba(0, 0, 0, 0.45)',
    colorTextDescription: 'rgba(0, 0, 0, 0.45)',
    colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
    colorSuccessBg: '#F6FFED',
    colorSuccessBorder: '#B7EB8F',

    // font tokens
    fontFamily:
      "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    fontSize: 14,
    fontSizeLG: 16,
    lineWidth: 1,
    lineWidthBold: 2,
    lineHeight: '22px',
    lineHeightLG: '24px',
    colorText: '#000000',

    editorToolbarDividerHeight: 18,
    editorToolbarButtonHeight: 28,
    editorToolbarHeight: 36,

    editorPaddingXXXS: 2,
    editorPaddingXXS: '3px',
    editorMarginXXS: '3px',

    editorHeadingMarginBottom1: '24px',
    editorFontSizeHeading1: '38px',
    editorLineHeight1: '46px',

    editorHeadingMarginBottom2: '20px',
    editorFontSizeHeading2: '24px',
    editorLineHeight2: '32px',

    editorHeadingMarginBottom3: '16px',
    editorFontSizeHeading3: '20px',
    editorLineHeight3: '28px',

    editorHeadingMarginBottom4: '8px',
    editorFontSizeHeading4: '16px',
    editorLineHeight4: '20px',

    editorHeadingMarginBottom5: '8px',
    editorFontSizeHeading5: '14px',
    editorLineHeight5: '16px',

    editorHeadingMarginBottom6: '8px',
    editorFontSizeHeading6: '12px',
    editorLineHeight6: '16px',

    editorFontSize: '16px',
    editorLineHeight: 1.5,
    editorHeadingFontWeight: 500,

    editorListMarginBottom: 0,
    editorListMarginTop: '12px',
    editorBorderRadius: 3,
  },
  components: {
    Anchor: { linkPaddingBlock: 4 },
    Avatar: { containerSizeLG: 40 },
    Input: { paddingInlineLG: 11, paddingBlockLG: 7, paddingBlock: 4 },
    Pagination: { borderRadius: 21, itemActiveBg: '#FFFFFF' },
    Dropdown: { paddingBlock: 5 },
    Button: { defaultBorderColor: '#D9D9D9', defaultBg: '#FFFFFF', defaultBorderColor: '#D9D9D9', paddingInline: 15 },
    Typography: {
      fontWeightStrong: 500,
      fontSize: 14,
      fontSizeHeading2: 30,
      lineHeightHeading2: '38px',
      fontSizeHeading3: 24,
      lineHeightHeading3: '32px',
      fontSizeHeading4: 20,
    },
    Menu: {
      itemHeight: 40,
      itemBorderRadius: 8,
      itemMarginBlock: 4,
      itemSelectedBg: '#E6F4FF',
      itemColor: 'rgba(0, 0, 0, 0.88)',
      iconSize: 14,
      iconMarginInlineEnd: 10,
      fontSize: 14,
      fontWeightStrong: 400,
    },
    Modal: {
      titleColor: 'rgba(0, 0, 0, 0.88)',
      titleFontSize: 16,
      fontWeightStrong: 600,
      footerBg: 'rgba(0, 0, 0, 0.00)',
    },
    Card: {
      padding: '16px',
    },
    Switch: {
      handleSize: 18,
    },
  },
  cssVar: true,
};

export default defaultTheme;
